module.exports = __webpack_public_path__ + "img/img4.d6d4f4f9.svg";